import * as CubiqTS from "shared/cubiq-model-multi-asset";

import {
  COLUMN_ORDER_DEALT_FWD_PTS,
  COLUMN_ORDER_BASE_FWD_PTS,
  COLUMN_ORDER_DEALT_TRACKING,
  COLUMN_ORDER_BASE_TRACKING,
  COLUMN_SPOT_MARKET_MID,
  COLUMN_BASE_SPOT_MARKET_MID,
  COLUMN_BASE_PERCENTAGE,
  COLUMN_DEALT_PERCENTAGE,
} from "shared/cubiq-services";

export const FORMAT_UNAVAILABLE_AS_DASH_CELL_EXPORT_KEYS = new Set([
  COLUMN_ORDER_DEALT_FWD_PTS,
  COLUMN_ORDER_BASE_FWD_PTS,
]);

export const FORMAT_UNAVAILABLE_RATE_CELL_EXPORT_KEYS = new Set([
  COLUMN_ORDER_DEALT_TRACKING,
  COLUMN_ORDER_BASE_TRACKING,
  COLUMN_SPOT_MARKET_MID,
  COLUMN_BASE_SPOT_MARKET_MID,
  COLUMN_ORDER_DEALT_FWD_PTS,
  COLUMN_ORDER_BASE_FWD_PTS,
  COLUMN_BASE_PERCENTAGE,
  COLUMN_DEALT_PERCENTAGE,
]);

const AG_GRID_CELL_CLEANUP_REG_EXP: RegExp = new RegExp(/(&#x200b;)|<[^>]*>|&nbsp;|&nbsp/, "ig");

export function AgGridCellExport(params) {
  let dasherizeStrikethrough = false;
  if (params.node.data.fullWidth) {
    return "";
  }
  let val: string | CubiqTS.BigNumber = params.value;
  let isString: boolean = typeof val == "string";

  if (!val) {
    return "";
  }
  if (FORMAT_UNAVAILABLE_AS_DASH_CELL_EXPORT_KEYS.has(params.column.colId)) {
    if (val == "") return "-";
  }

  if (FORMAT_UNAVAILABLE_RATE_CELL_EXPORT_KEYS.has(params.column.colId) && isString) {
    dasherizeStrikethrough = (val as string).indexOf("no-rate-strike") > -1;
  }

  if (val instanceof CubiqTS.BigNumber) val = val.toString();
  else if (isString) val = val.replace(AG_GRID_CELL_CLEANUP_REG_EXP, "");

  if (dasherizeStrikethrough) val = `-${val}-`;

  return val;
}
